import { useMutation, useQueryClient } from 'react-query';
import { fetchWorkflowDirection, WorkflowDirection } from './useWorkflowNextMutation';
import { queryKeys } from './queryKeys';

export const WORKFLOW_PREVIOUS_MK = 'workflowPrevious';

interface MutationParams {
  clientId: string;
}

export const useWorkflowPreviousMutation = ({ clientId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(fetchWorkflowDirection(WorkflowDirection.Previous), {
    mutationKey: WORKFLOW_PREVIOUS_MK,

    onSuccess(data) {
      queryClient.setQueryData(queryKeys.workflowData(clientId, data.Route.Params.pageId), data);
    },
  });
};
